// /stacks/traffic/dev/frontend/src/lib/links.js
import { fmtAPIDate } from "./urlState";

// Builds /dev/sightings?period=custom&start=...&end=...&cameras=...&plate=...
export function sightingsHref(startDate, endDate, camKeys, plate) {
  const enc = (s) => encodeURIComponent(s);
  const ts  = (d) => fmtAPIDate(d);

  const camsParam = Array.isArray(camKeys) && camKeys.length
    ? `&cameras=${enc(camKeys.join(","))}`
    : "";

  let plateParam = "";
  const p = String(plate || "").trim();
  if (p) {
    if (p.startsWith("=")) plateParam = `&plate=${enc(p.slice(1))}&exact=true`;
    else plateParam = `&plate=${enc(p)}`;
  }

  return `/dev/sightings?period=custom&start=${enc(ts(startDate))}&end=${enc(ts(endDate))}${camsParam}${plateParam}`;
}

export function goSightings(startDate, endDate, camKeys, plate) {
  window.location.href = sightingsHref(startDate, endDate, camKeys, plate);
}
